import {Component, ViewChild, ViewContainerRef} from '@angular/core';
import {MatDialog} from '@angular/material/dialog';
import {SlideLeft, SlideRight} from 'src/app/Util/AnimationUtil';

import {BasePanelSlide} from 'src/app/View/BaseUI/BasePanelSlide';
import {ReserveUpdateDetailPanelController} from './ReserveUpdateDetailPanelController';
import {MatSelectChange} from '@angular/material/select';
import {ReservationSaveDTOInterface} from '../../../../../../../DTO/ReservationSaveDTOInterface';
import {ReservationDetailDTOInterface} from '../../../../../../../DTO/ReservationDetailDTOInterface';

// @ts-ignore
import * as cloneDeep from 'clone-deep';
import {MstExaminationDTOInterface} from '../../../../../../../DTO/MstExaminationDTOInterface';
import {DepartmentListDTOInterface} from '../../../../../../../DTO/DepartmentListDTOInterface';
import {DeviceTypeDTOInterface} from '../../../../../../../DTO/DeviceTypeDTOInterface';
import {ReserveAlertListDTOInterface} from '../../../../../../../DTO/ReserveAlertListDTOInterface';
import {MatRadioChange} from '@angular/material/radio';

@Component({
	selector: 'ReserveUpdateDetailPanelComponent',
	templateUrl: './ReserveUpdateDetailPanelComponent.html',
	styleUrls: ['../../Reserve.scss', './ReserveUpdateDetailPanelComponent.scss'],
	animations: [
		SlideLeft,
		SlideRight
	],
})
export class ReserveUpdateDetailPanelComponent extends BasePanelSlide {

	// コンポーネントを操作するコントローラー
	public combineCtrl: ReserveUpdateDetailPanelController;

	// 自分自身のコンポーネント名称
	public componentName = 'ReserveUpdateDetailPanelComponent';

	public eventSelectDate: () => void;
	public eventSetReserveSaveData: (reserve: ReservationSaveDTOInterface) => void;
	// 予約詳細画面の表示
	public eventShowDetailView: (reserveId: number) => void;

	public reserveDetail: ReservationDetailDTOInterface = {
		mstClinic: {
			name: '',
		},
		mstDoctor: {
			name: '',
		}
	} as ReservationDetailDTOInterface;

	public reserveModel: ReservationSaveDTOInterface = {
		id: 0,
		clinicId: 0,
		doctorId: 0,
		departmentId: 1,
		userId: 0,
		reservationDate: '',
		reservationFrom: '',
		reservationTo: '',
		exam: [],
		examList: [],
		memo: '',
		memoUser: '',
		cancelDate: '',
		visitType: 'FIRST',
		appointmentType: 'VISIT',
	};

	public visitTypeList: Array<any> = [
		{id: 'FIRST', name: '初診'},
		{id: 'AGAIN', name: '再診'}
	];

	public appointmentTypeList = [
		{id: 'VISIT', name: '来院予約'},
		{id: 'ONLINE', name: 'オンライン診療予約'}
	];

	// デバイスリスト
	public deviceTypeList: Array<DeviceTypeDTOInterface> = [];

	// 来院診療科
	public departmentVisitList: Array<DepartmentListDTOInterface> = [];

	// オンライン診療科
	public departmentOnlineList: Array<DepartmentListDTOInterface> = [];

	// 画面のselectで表示するリスト
	// departmentVisitListかdepartmentOnlineListが入る
	public departmentList: Array<DepartmentListDTOInterface> = [];
	public selectedDepartmentCaution = '';

	// 診察内容
	// 単一選択用にselectedExamを設定、複数選択になった場合は不要
	public examList: Array<MstExaminationDTOInterface> = [
		{id: 0, name: '発熱・かぜ・その他体調不良', description: '', caution: ''},
	];
	public selectedExam = 0;

	// 来院、オンライン、初診、再診選択時の注意事項
	// 親から設定される
	public alertList: ReserveAlertListDTOInterface;
	// 項目選択時に表示するアラート
	public selectedAppointmentTypeCaution: Array<{title: string; content: string}> = [];
	public selectedVisitTypeCaution: Array<{title: string; content: string}> = [];

	// エラーメッセージ
	public errorMessageList = {
		clinic: '',
		department: '',
		appointmentType: '',
		visitType: '',
	};

	/**
	 * constructor
	 * @param dialogCtrl ダイアログコントローラ
	 */
	constructor(
		public dialogCtrl: MatDialog // ダイアログ機能
	) {
		// Angularのコンポーネントなので上位を呼ぶ。
		super();
		// BaseViewでコントローラのインスタンスを作成して保持する（ロジック系はコントローラに実装する）
		this.createController(ReserveUpdateDetailPanelController);
	}

	/**
	 * 開始処理
	 */
	public async start() {

		this.log('ReserveUpdateDetailPanelComponent::start()');
		this.log(this.reserveModel);
		this.setDepartmentList(this.reserveModel.appointmentType);
		this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);

		// 選択されている診療科注意事項の設定
		const selectedDepartment = this.departmentList.find(item => item.id === this.reserveModel.departmentId);
		this.selectedDepartmentCaution = selectedDepartment.caution;

		// 選択されている来院・オンラインの注意事項設定
		switch (this.reserveModel.appointmentType) {
			case 'VISIT':
				this.selectedAppointmentTypeCaution = this.alertList.VISIT;
				break;
			case 'ONLINE':
				this.selectedAppointmentTypeCaution = this.alertList.ONLINE;
				break;
		}
		// 選択されている初診・再診の注意事項設定
		switch (this.reserveModel.visitType) {
			case 'FIRST':
				this.selectedVisitTypeCaution = this.alertList.FIRST;
				break;
			case 'AGAIN':
				this.selectedVisitTypeCaution = this.alertList.AGAIN;
				break;
		}

		await this.slideIn();
	}

	/**
	 * 診察内容のリストをセットする
	 * @param departmentId
	 * @param appointmentType
	 * @private
	 */
	private setExamList(departmentId: number, appointmentType: string) {

		let examList = [];
		for (const department of this.departmentList) {
			if (department.id === departmentId) {
				switch (appointmentType) {
					case 'VISIT':
						examList = department.mstExamination.visit;
						break;

					case 'ONLINE':
						examList = department.mstExamination.online;
						break;
				}
			}
		}

		this.examList = [];
		for (const exam of examList) {
			exam.isChecked = false;
			for (const selectedExam of this.reserveModel.exam) {
				if (selectedExam == exam.id) {
					exam.isChecked = true;
					this.selectedExam = exam.id;
					continue;
				}
			}

			this.examList.push(exam);
		}

	}

	/**
	 * 診療科のデータ設定
	 * 来院、オンラインにより選択肢が異なる
	 * @param appointmentType
	 * @private
	 */
	private setDepartmentList(appointmentType: string) {
		let departmentList = [];
		switch (appointmentType) {
			case 'VISIT':
				departmentList = this.departmentVisitList;
				break;

			case 'ONLINE':
				departmentList = this.departmentOnlineList;
				break;
		}

		this.departmentList = departmentList;
	}

	/**
	 * 日時選択画面へ遷移
	 */
	public async selectDate() {

		let isShowDialog = true;
		const errorMessages = [];
		if (this.reserveModel.clinicId === 0) {
			isShowDialog = false;
			errorMessages.push('クリニックが選択されていません。');
		}
		if (this.reserveModel.departmentId === 0) {
			isShowDialog = false;
			errorMessages.push('診療科が選択されていません。');
		}

		const examList = [];
		for (const exam of this.examList) {
			if (exam.isChecked === true) {
				examList.push(exam);
			}
		}
		if (examList.length === 0) {
			isShowDialog = false;
			errorMessages.push('診察内容が選択されていません。');
		}

		if (isShowDialog === false) {
			await this.showAlertDialog('エラー', errorMessages.join('<br>'));
			return;
		}

		this.reserveModel.examList = examList;

		await this.eventSetReserveSaveData(this.reserveModel);
		await this.eventSelectDate();
	}

	/**
	 * select選択時のコールバック
	 * @param event
	 * @param name
	 */
	public async onSelectionChange(event: MatSelectChange, name: string): Promise<void> {

		switch (name) {
			// 来院・オンライン選択
			// 診療科リストを入れ替える
			case 'appointmentType':
				this.setDepartmentList(this.reserveModel.appointmentType);
				this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);
				// 診療科を未選択に戻す
				this.reserveModel.departmentId = 0;
				// 日時選択をリセット
				this.reserveModel.reservationDate = '';
				this.reserveModel.reservationFrom = '';
				this.reserveModel.reservationTo = '';
				this.reserveModel.doctorId = 0;

				// 注意事項を入れ替える
				this.selectedAppointmentTypeCaution = [];
				switch (this.reserveModel.appointmentType) {
					case 'VISIT':
						this.selectedAppointmentTypeCaution = this.alertList.VISIT;
						break;
					case 'ONLINE':
						this.selectedAppointmentTypeCaution = this.alertList.ONLINE;
						break;
				}
				break;

			// 診療科選択
			// 医師一覧の更新と選択医師の変更、タイムテーブルの更新
			case 'departmentId':
				this.reserveModel.exam = [];
				this.setExamList(this.reserveModel.departmentId, this.reserveModel.appointmentType);
				// 日時選択をリセット
				this.reserveModel.reservationDate = '';
				this.reserveModel.reservationFrom = '';
				this.reserveModel.reservationTo = '';
				this.reserveModel.doctorId = 0;

				const selectedDepartment = this.departmentList.find(item => item.id === this.reserveModel.departmentId);
				this.selectedDepartmentCaution = selectedDepartment.cautionHtml;

				break;

			case 'visitType':
				this.selectedVisitTypeCaution = [];
				this.errorMessageList.visitType = '';
				switch (this.reserveModel.visitType) {
					case 'FIRST':
						this.selectedVisitTypeCaution = this.alertList.FIRST;
						break;
					case 'AGAIN':
						this.selectedVisitTypeCaution = this.alertList.AGAIN;
						break;
				}
				break;
		}
	}

	/**
	 * 診察内容変更時のコールバック
	 * 単一選択時に利用、今後複数選択になった場合は
	 * onSelectionChange()で対応になるので不要となる
	 *
	 * @param event
	 */
	public async onExamRadioChange(event: MatRadioChange): Promise<void> {
		this.selectedExam = event.value;
		for (const exam of this.examList) {
			if (exam.id === this.selectedExam) {
				exam.isChecked = true;
			} else {
				exam.isChecked = false;
			}
		}
	}

	/**
	 * onClickClosePanel
	 * パネルを閉じたときの処理
	 */
	public async onClickClosePanel() {
		await this.eventShowDetailView(this.reserveModel.id);

	}
}
